import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, } from "styled-components";

import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CssBaseline from '@material-ui/core/CssBaseline'
import OldMenu from '../components/organisms/Menu'
import Submenu from '../components/organisms/Submenu'
import { Alerts } from "./global/alerts";
import { Header } from "../components/header";
import { Menu } from '../components/menu'
import { ImpersonationBanner } from "../components/impersonation";
import { getCurrentThemeStyle, redirectByDepartment } from "../services/functions";
import { useThemes } from "../providers/theme";
import { useLocation, useHistory } from "react-router-dom";
import { controllerWhatsapp } from "../services/controllers/service-activation";
import { CustomerDetailsDrawer } from "./global/drawers";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    background: "transparent",
    boxShadow: "none",
    zIndex: 15,
  },
  toolbar: {
    alignItems: "center",
    color: "#666666",
    display: "flex",
    fontWeight: "bold",
    justifyContent: "space-between",
    padding: 0,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    overflowX: "hidden",
  },
}));

function BasePage({ children, pageTitle, extendStyles }) {
  const CLWhatsapp = controllerWhatsapp()

  const location = useLocation();
  const history = useHistory();

  const classes = useStyles()
  const { theme } = useThemes();
  const themeStyle = getCurrentThemeStyle()

  const redirect = redirectByDepartment(location.pathname)
  if (redirect) {
    history.push(redirect)
    // return null
  }

  useEffect(() => {
    CLWhatsapp.whatchWhatsappConnection()
  })

  return (
    <ThemeProvider theme={themeStyle}>
      <div className="flex">
        <div className="w-full h-screen flex flex-col items-start justify-start">
          <ToastContainer />
          <Alerts.AgendaAlerts />
          <CustomerDetailsDrawer />
          <CssBaseline />
          <ImpersonationBanner />
          <Header title={pageTitle} />
          {/* <OldMenu />*/}
          <div className="flex w-full flex-1 min-h-0">
            <Menu />
            <div className="flex flex-1 min-w-0 overflow-auto pt-4 pl-4">
              <main className="flex w-full overflow-auto flex-1 h-full flex-col">
                {children}
              </main>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default BasePage;
